<label [for]="id" [ngClass]="['control-label', _labelClass]">Agence</label>
<div [ngClass]="_fieldClass">
	<extended-filterable-select
		[id]="id"
		[list]="agences"
		[inputClass]="'form-control'"
		[disabled]="disabled"
		[labelGetter]="getAgenceLabel"
		[selectedItem]="selectedAgence"
		(selectedItemChange)="onSelectedAgenceChange($event)"
		>
	</extended-filterable-select>
</div>